import { deepEqual } from 'fast-equals';
import { useRef, useMemo } from 'react';

function useReferenceSafeObject(value) {
  const valueRef = useRef(value);
  return useMemo(() => {
    if (deepEqual(value, valueRef.current)) {
      return valueRef.current;
    }
    valueRef.current = value;
    return value;
  }, [value]);
}

export { useReferenceSafeObject as default };
//# sourceMappingURL=useReferenceSafeObject.mjs.map
